import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../actions/types';
import { requestAPI } from '../services/request';
import { API } from '../services/api';
import { ResponseStatus } from '../../constants/constant';
import { store } from '../store';
import { hideLoading, showLoading } from '../actions';

function* homescreen(action) {
  let response = null;
  store.dispatch(showLoading());
  try {
    response = yield call(requestAPI, API.HOME_SCREEN, API.POST, action.params);

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.HOME_SCREEN_SUCCEEDED,
        data: response.data
      });
    } else if (response.status === ResponseStatus.FAILURE) {
      yield put({ type: types.HOME_SCREEN_FAILED, error: response });
    } else {
      yield put({ type: types.HOME_SCREEN_FAILED, error: response });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.HOME_SCREEN_FAILED, error });
  }
  store.dispatch(hideLoading());
}

export function* watchHomeScreen() {
  yield takeLatest(types.HOME_SCREEN_REQUESTED, homescreen);
}
